var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 10 10)",
    d: "M4.16634 10.8333H13.4747L9.40801 14.8999C9.08301 15.2249 9.08301 15.7583 9.40801 16.0833C9.73301 16.4083 10.258 16.4083 10.583 16.0833L16.0747 10.5916C16.3997 10.2666 16.3997 9.7416 16.0747 9.4166L10.5913 3.9166C10.2663 3.5916 9.74134 3.5916 9.41634 3.9166C9.09134 4.2416 9.09134 4.7666 9.41634 5.0916L13.4747 9.1666H4.16634C3.70801 9.1666 3.33301 9.5416 3.33301 9.99994C3.33301 10.4583 3.70801 10.8333 4.16634 10.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevPage);
export default __webpack_public_path__ + "static/media/prev-page.709b6b09ed55710ab51c8fffb93aea37.svg";
export { ForwardRef as ReactComponent };